import { useTheme } from '@emotion/react';
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useMediaQuery } from "@mui/material";
import { ResetPassword } from "./changePassword";
import { Wrapper } from "../../components";
import { CompanyName } from "../../assets";
import PersonalDetail from "./PersonalDetail";
import MobileProfile from './MobileProfile';

import BusinessIcon from '@mui/icons-material/Business';
import PersonIcon from '@mui/icons-material/Person';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import PasswordIcon from '@mui/icons-material/Password';

export const Profile = () => {
  const theme = useTheme();
  const [current, setCurrent] = useState(0);
  const { user } = useSelector((state) => state.auth);

  const PROFILE_KEYS = useMemo(() => {
    if (user && Object.keys(user).length !== 0) {
      return [
        { label: "Company Name", value: user?.company?.name },
        { label: "Email Id", value: user?.company?.email },
        { label: "Contact No.", value: user?.company?.contactNumber },
        { label: "GSTN", value: user?.company?.GSTN },
        { label: "PAN", value: user?.company?.PAN },
        { label: "TAN", value: user?.company?.TAN },
        { label: "Address", value: user?.company?.address },
      ];
    }
    return [];
  }, [user]);

  const isMobile = useMediaQuery("(max-width:899px)");

  return user ? (
    <>
      {isMobile ? (
        <MobileProfile />
      ) : (
        <Wrapper sx={{ height: "calc(100vh - 30px)", overflow: "hidden" }}>
          <Paper
            sx={{
              display: "flex",
              flexDirection: "row",

              overflow: "hidden",
              mt: 8,
              ml: 2,
            }}
          >
            {/* Sidebar Navigation */}
            <Stack
              sx={{
                flex: 0.25,
                minWidth: "240px",
                background: theme.palette.background.main,
                p: 2,
                borderRight: `1px solid ${theme.palette.divider}`,
              }}
              spacing={2}
            >
              {[
                { id: 0, label: "Company Profile", icon: <BusinessIcon /> },
                { id: 2, label: "Personal Details", icon: <PersonIcon /> },
                { id: 1, label: "Change Password", icon: <PasswordIcon /> },
              ].map((item) => (
                <Button
                  key={item.id}
                  startIcon={item.icon}
                  onClick={() => setCurrent(item.id)}
                  sx={{
                    justifyContent: "flex-start",
                    px: 2,
                    py: 1.5,
                    fontSize: "1.4rem",
                    fontWeight: 500,
                    borderRadius: 2,
                    backgroundColor:
                      current === item.id
                        ? theme.palette.background.white
                        : "transparent",
                    color:
                      current === item.id
                        ? theme.palette.primary.main
                        : theme.palette.text.primary,
                    boxShadow: current === item.id ? 1 : "none",
                    "&:hover": {
                      backgroundColor:
                        current === item.id
                          ? theme.palette.background.white
                          : "rgba(255,255,255,0.08)",
                    },
                  }}
                >
                  {item.label}
                </Button>
              ))}
            </Stack>

            {/* Content Area */}
            <Box
              sx={{
                flex: 0.75,
                p: 4,
                overflowY: "auto",
                height: "calc(100vh - 120px)",
              }}
            >
              {current === 0 && (
                <Stack direction="row" spacing={4}>
                  {/* Left - Company Info */}
                  <Stack sx={{ flex: 0.7 }} spacing={2}>
                    {PROFILE_KEYS.map((item) => (
                      <Paper
                        key={item.label}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          p: 2,
                          borderRadius: 2,
                          boxShadow: 1,
                          bgcolor: theme.palette.grey[50],
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "1.4rem",
                            fontWeight: 500,
                            color: theme.palette.grey[800],
                          }}
                        >
                          {item.label}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "1.4rem",
                            color: theme.palette.text.secondary,
                          }}
                        >
                          {item.value || "-"}
                        </Typography>
                      </Paper>
                    ))}
                  </Stack>

                  {/* Right - Company Logo */}
                  <Stack
                    sx={{
                      flex: 0.3,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      component="img"
                      src={CompanyName}
                      sx={{
                        maxWidth: "100%",
                        borderRadius: 2,
                        boxShadow: 2,
                      }}
                    />
                  </Stack>
                </Stack>
              )}

              {current === 1 && <ResetPassword />}
              {current === 2 && <PersonalDetail />}
            </Box>
          </Paper>
        </Wrapper>
      )}
    </>
  ) : null;
};

export default Profile;
